export interface UserBlockRuleRow {
    userId: bigint;
    rule: number; // BlockRule flags
    comment: string;
    created: string;
    updated: string;
}

export const BlockRule = {
    None: 0,
    Withdraw: 1 << 0,
    Deposit: 1 << 1,
    ReceiveItems: 1 << 2,
    Buy: 1 << 3,
    Sell: 1 << 4,
    OperationsHistoryPage: 1 << 5,
} as const;

export type BlockRuleKey = keyof typeof BlockRule;

export function getBlockRuleLabels(): { value: number, label: string }[] {
    return [
        {value: BlockRule.Withdraw, label: 'Вывод'},
        {value: BlockRule.Deposit, label: 'Пополнение'},
        {value: BlockRule.ReceiveItems, label: 'Получение предметов'},
        {value: BlockRule.Buy, label: 'Покупка'},
        {value: BlockRule.Sell, label: 'Продажа'},
        {value: BlockRule.OperationsHistoryPage, label: 'История операций'},
    ];
}


